const pre = window.host + '/' + window.app + '/'
// const pre = ''
const set = (name, value,time=0) => {
    time = parseInt(time)
    if(time !== 0){
        const nowStamp = new Date().getTime();
        time = nowStamp + time*60*1000;
    }
    const data = {
        value:value,
        time:time
    }
    if (window.storageType === 'local') {
        localStorage.setItem(pre + name, JSON.stringify(data))
    } else {
        sessionStorage.setItem(name, JSON.stringify(data))
    }
}
const get = (name) => {
    let res;
    if (window.storageType === 'local') {
        res = localStorage.getItem(pre + name)
    } else {
        res = sessionStorage.getItem(name)
    }
    if(res===null) return null;
    res = JSON.parse(res);
    if(res.time !== 0 && new Date().getTime() > res.time) {
        return null;
    }else{
        return res.value
    }
}
const remove = (name) => {
    if (window.storageType === 'local') {
        localStorage.removeItem(pre + name)
    } else {
        sessionStorage.removeItem(name)
    }
}
const clear = (name)=> {
    if (window.storageType === 'local') {
        localStorage.clear()
    } else {
        sessionStorage.clear()
    }
}
export default {
    set,
    get,
    remove,
    clear
};
